import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  production: false,
  
  TURNSTILE_SITE_KEY: '0x4AAAAAACEIBQNWJiAal5-l',
  apiUrl: 'https://digital-eol-cv-dev-ms.api.tatamotors/',
  baseUrl: 'https://rewireparts-dev.home.tatamotors/', // Port 1001
  // baseUrl: 'https://rewireparts-qa.home.tatamotors/'    // Port 1002

  s3BucketUrl: 'https://dsxtzbjg5eg7r.cloudfront.net',

};
